import React, { useState, useEffect, useCallback } from "react";
import CustomButton from "../../../../atoms/CustomButton";
import Download from "../../../../icons/Import";
import Filter from "../../../../icons/Filter";
import CustomDataGrid from "../../../../organisms/CustomDatagrid";
import Modal from "../../../../organisms/modals/Modal";
import CustomMenu from "../../../../atoms/CustomMenu";
import { v4 as uuidv4 } from "uuid";
import View from "../../../../icons/View";
import Edit from "../../../../icons/Edit";
import Delete from "../../../../icons/Delete";
import VerticalMenu from "../../../../icons/VerticalMenu";
import { getData, deleteData } from "../../../../../services";
import moment from "moment/moment";
import { useCookies } from "react-cookie";
import Form from "./Form";
import Search from "../../../../molecules/search";
import Pagination from "../../../../molecules/Pagination";
import DeleteModal from "../../../../organisms/modals/DeleteModal";
import Import from "../../../../molecules/Import";
import {
  getdepartmentList,
  getEmployeeList,
  getRolesList,
} from "../../../../../services/basicGets";
import NoContentCard from "../../../../atoms/NoContentCard";
import NoContentIcon from "../../../../icons/NocontentIcon";
import toast from "react-hot-toast";
import {
  errorStyles,
  confimationStyles,
} from "../../../../../assets/styles/toast";
import { useSelector } from "react-redux";
import { Tooltip } from "@mui/material"; // Add this import

const RoleManagement = () => {
  const [cookies] = useCookies([]);
  const [selectedRow, setSelectedRow] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [searchedValue, setSearchedValue] = useState();
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [roles, setRoles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [modalState, setModalState] = useState({
    isModalOpen: false,
    modalData: null,
    isDeleteModalOpen: false,
    modalId: "",
    name: "",
  });

  const accessData = useSelector((state) => state.accessDetails?.accessData);
  const isAdmin = accessData?.role?.label === "Admin";

  const DeptManagementAccess =
    accessData?.access?.find((module) => module.module === "Role Management") ||
    {};

  // Determine if user can edit or delete
  const canEdit = isAdmin || DeptManagementAccess?.is_edit;
  const canDelete = isAdmin || DeptManagementAccess?.is_delete;

  const showMenu = canEdit || canDelete;

  useEffect(() => {
    (async () => {
      const resRoles = await getRolesList({
        token: cookies.e_t,
      });
      setRoles(resRoles);
    })();
  }, []);

  const getUserData = useCallback(async () => {
    try {
      setIsLoading(true);
      const res = await getData({
        endpoint: "Role/GetAllRoles",
        params: {
          search_query: searchedValue,
          page: currentPage,
          page_limit: itemsPerPage,
        },

        token: cookies.e_t,
      });
      if (res) {
        const newRes = res;
        const dataWithSNo = newRes?.data?.roles.map((item, index) => ({
          ...item,
          sno: (currentPage - 1) * itemsPerPage + index + 1,
        }));
        setTableData({ ...newRes, data: dataWithSNo });
        // setTableData(res?.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [cookies.e_t, currentPage, itemsPerPage, searchedValue]);

  useEffect(() => {
    getUserData();
  }, [getUserData]);

  const menu = [
    canEdit && {
      icon: <Edit height="20" width="20" />,
      label: "Edit",
      onClick: () => {
        setAnchorEl(null);
        handleEdit(selectedRow);
      },
    },
    canDelete && {
      icon: <Delete />,
      label: "Delete",
      onClick: () => {
        setAnchorEl(null);
        handleDeleteModal(selectedRow);
      },
    },
  ].filter(Boolean);

  const handleDeleteModal = (data) => {
    setModalState((prevState) => ({
      ...prevState,
      isDeleteModalOpen: true,
      modalId: data.role_id,
      name: data.role_name,
    }));
  };

  const handleDeletion = async () => {
    try {
      await deleteData({
        endpoint: "Role/DeleteRoleById",
        params: {
          role_id: modalState.modalId,
        },
      });
      toast.success("Role Deleted Sucessfully", {
        style: confimationStyles,
        duration: 1000,
      });
      getUserData();
      setModalState((prevState) => ({
        ...prevState,
        isDeleteModalOpen: false,
      }));
      getUserData();
    } catch (error) {
      toast.error("Role already mapped.", {
        style: errorStyles,
        duration: 1000,
      });

      setModalState((prevState) => ({
        ...prevState,
        isDeleteModalOpen: false,
      }));

      console.log(error);
    }
  };

  const handleStatusMenu = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  const handleItemsPerPageChange = useCallback((perPage) => {
    setCurrentPage(1);
    setItemsPerPage(perPage);
  }, []);

  const handleEdit = (tableData) => {
    setModalState((prevState) => ({
      ...prevState,
      modalId: tableData.id,
      modalData: tableData,
      isModalOpen: true,
      title: "Edit Role",
    }));
  };

  const columns = [
    {
      field: "sno",
      headerName: "S.no",
      flex: 0.5,
      sortable: true,
    },
    {
      field: "role_name",
      headerName: "Role",
      flex: 1,
      sortable: true,
    },
    {
      field: "created_at",
      headerName: "Created At",
      flex: 1,
      sortable: true,
      renderCell: (params) => {
        return (
          <span>
            {params?.row?.created_at &&
              moment(params.row.created_at).format("DD/MM/YYYY")}
          </span>
        );
      },
    },
    {
      field: "actions",
      headerName: "",
      flex: 0.2,
      renderCell: (params) => {
        const isAdminRole = params.row.role_name === "Admin";

        if (isAdminRole) {
          return (
            <Tooltip title="Admin role can't be modified" arrow>
              <div style={{ opacity: 0.5, cursor: "not-allowed" }}>
                <VerticalMenu />
              </div>
            </Tooltip>
          );
        }

        if (!showMenu) return null;

        return (
          <div className="table-icons-container">
            <div onClick={(event) => handleStatusMenu(event, params.row)}>
              <VerticalMenu />
            </div>
            <CustomMenu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              items={menu}
            />
          </div>
        );
      },
    },
  ];

  const openModal = (title, data) => {
    const modalId = uuidv4();
    setModalState((prevState) => ({
      ...prevState,
      modalId,
      isModalOpen: true,
      title,
      modalData: data,
    }));
  };

  const closeModal = () => {
    // if(type === 'submitted'){
    setModalState((prevState) => ({ ...prevState, isModalOpen: false }));
    // } else {
    //   // setModalState((prevState) => ({ ...prevState, isModalOpen: false }));
    //   setIsFormDirty(true)
    //   setModalState((prevState) => ({ ...prevState, isModalOpen: false }));
    // }
  };

  const CustomNoRowsOverlay = React.memo(() => {
    return (
      <>
        {/* {!!searchedValue ? (
          <NoContentCard
            title="No Record Found"
            type="Company"
            icon={<NoContentIcon />}
            small={true}
          />
        ) : ( */}
        <NoContentCard
          title="No Roles Found"
          type="Employee"
          subtitle={"Try refreshing or add new information to begin."}
        />
        {/* )} */}
      </>
    );
  });

  return (
    <div id="User-Management">
      <div className="d-flex justify-content-between mb-3">
        <h3 className="h2-j semi-light mb-0">Roles</h3>
        <div className="d-flex gap-2">
          <Search
            placeholder="Search"
            onSearchEmit={(item) => {
              if (currentPage !== 1) {
                setCurrentPage(1);
              }
              setSearchedValue(item);
            }}
          />
          {canEdit && (
            <CustomButton
              text="Add Role"
              type="btn-outline-primary"
              handleClick={() => openModal("Add Role")}
            />
          )}
        </div>
      </div>
      <div className="mt-3">
        <CustomDataGrid
          columns={columns}
          CustomNoRowsOverlay={CustomNoRowsOverlay}
          rows={tableData.data || []}
          getRowId={(row) => row.role_id}
          isLoadingStateProvided={true}
          isLoading={isLoading}
          onCellClick={(params) => {

            if (
              params.field !== "actions" && // Ensure the clicked cell is not an action button
               canEdit && // Check if editing is allowed
              params?.row?.role_name !== "Admin" // Ensure "Admin" row is not editable
            ) {
              handleEdit(params.row); // Call handleEdit with the row data
            }
          }}
          
          canEdit={canEdit}
        />
      </div>

      {tableData?.total_records > 10 && (
        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={tableData?.total_records}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          onItemsPerPageChange={handleItemsPerPageChange}
        />
      )}

      {modalState?.isModalOpen && (
        <Modal
          id={modalState?.modalId}
          title={modalState.title}
          isActive={modalState?.isModalOpen}
          onClose={closeModal}
          takeConfirmation={isFormDirty ? true : false}
          width="900px"
          maxHeight="700px"
          extrastyle={{ overflow: "scroll", paddingTop: "" }}
          paddingProp={true}
        >
          <Form
            onFormDirty={setIsFormDirty}
            initialData={
              modalState.title === "Edit Role" ? modalState.modalData : null
            }
            refetchData={getUserData}
            rolesList={roles}
            onClose={() => closeModal("submit")}
          />
        </Modal>
      )}

      {modalState.isDeleteModalOpen && (
        <DeleteModal
          name={modalState.name}
          id={modalState.modalId}
          isActive={modalState.isDeleteModalOpen}
          onClose={() =>
            setModalState((prevState) => ({
              ...prevState,
              isDeleteModalOpen: false,
            }))
          }
          title="Role"
          onClick={handleDeletion}
        />
      )}
    </div>
  );
};

export default RoleManagement;
